/**
 * SuperballBingoStyle3 sections — Minimal/Clean design.
 * Simple centered title with ball.
 */
import React from 'react'
import InlineTranslationEdit from '../../../components/InlineTranslationEdit'
import HeroPartnerGlassSelect from '../../../components/HeroPartnerGlassSelect'
import BingoBall from '../../../components/BingoBall'
import { useContent } from '../../../contexts/ContentContext'

/**
 * Hero section — minimal clean design.
 */
export function BingoStyle3HeroSection({ editMode, handleTranslationUpdate }) {
  const { c } = useContent()

  return (
    <div className="max-w-3xl mx-auto px-4 text-center">
      <h1 className="text-3xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
        <InlineTranslationEdit
          translationKey="superballBingo.title"
          value={c('superballBingo.title', 'Superball Bingo')}
          fallback="Superball Bingo"
          onUpdate={handleTranslationUpdate}
          editMode={editMode}
        />
      </h1>
      <p className="text-lg text-gray-600 dark:text-gray-400 mb-6">
        <InlineTranslationEdit
          translationKey="superballBingo.subtitle"
          value={c('superballBingo.subtitle', 'Draw the golden Superball to win the progressive jackpot')}
          fallback="Draw the golden Superball to win the progressive jackpot"
          onUpdate={handleTranslationUpdate}
          editMode={editMode}
        />
      </p>
      <HeroPartnerGlassSelect className="mx-auto mb-6 w-full max-w-md" />
      <div className="flex justify-center">
        <BingoBall number={76} size="xl" />
      </div>
    </div>
  )
}
